// Simple ID generator (can be replaced with nanoid later)
let idCounter = 0;
export function generateId(): string {
  return `wp_${Date.now()}_${++idCounter}`;
}
